////////////////////////////////////////////////////////////////////////////////
//                                                                             /
//                                                                             /
//  (C) Copyright 2025 Autodesk, Inc. All rights reserved.                     /
//                                                                             /
//                       ****  CONFIDENTIAL MATERIAL  ****                     /
//                                                                             /
//  The information contained herein is confidential, proprietary to           /
//  Autodesk, Inc., and considered a trade secret.  Use of this information    /
//  by anyone other than authorized employees of Autodesk, Inc. is granted     /
//  only under a written nondisclosure agreement, expressly prescribing        /
//  the scope and manner of such use.                                          /
//                                                                             /
////////////////////////////////////////////////////////////////////////////////

import {DefaultItem} from "@adsk/alloy-react-dropdown";
import {BuiltInFileTypes} from "../../Enums";

export class SettingsSourceState {
  FilterOpen = false;
  SelectedFileTypes: DefaultItem[];

  constructor() {
    this.SelectedFileTypes = [];
  }
}